const PageTransact = () => import('@/modules/task/transact/PageTransact')
export default [
  {
    path: '/task',
    name: 'task',
    component: PageTransact,
    meta: {
      title: '我的待办',
    },
  },
]
